document.addEventListener('DOMContentLoaded', () => {
    if (typeof Glide === 'undefined') return;

    const sections = document.querySelectorAll('.custom-section-slider');

    sections.forEach((section) => {
        const glideRoot = section.querySelector('.glide');
        if (!glideRoot) return;

        const controlsContainer = glideRoot.querySelector('.glide__controls');
        const controlButtons = controlsContainer ? Array.from(controlsContainer.querySelectorAll('.glide__control')) : [];

        const glide = new Glide(glideRoot, {
            type: 'slider',
            perView: 1,
            gap: 0,
            autoplay: false,
            hoverpause: true,
            keyboard: true,
        });

        section.querySelectorAll('video').forEach((v) => {
            v.muted = true;
            v.playsInline = true;
        });

        let rafId = null;
        let activeVideo = null;
        let activeControlProgress = null;

        const cancelRaf = () => {
            if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = null;
            }
        };

        const resetAllProgressBars = () => {
            controlButtons.forEach((btn) => {
                const p = btn.querySelector('.glide__progress');
                if (p) {
                    p.style.width = '0%';
                    p.setAttribute('aria-valuenow', '0');
                }
                btn.classList.remove('glide__control--active');
            });
        };

        const pauseAllVideos = () => {
            section.querySelectorAll('video').forEach((v) => {
                try { v.pause(); } catch (e) {}
            });
        };

        const updateProgressFromVideo = (video, progressEl) => {
            if (!video || !progressEl) return;

            const tick = () => {
                if (video.duration && isFinite(video.duration) && video.duration > 0) {
                    const pct = Math.min(100, Math.max(0, (video.currentTime / video.duration) * 100));
                    progressEl.style.width = pct + '%';
                    progressEl.setAttribute('aria-valuenow', String(Math.round(pct)));
                }
                if (activeVideo === video) {
                    rafId = requestAnimationFrame(tick);
                } else {
                    cancelRaf();
                }
            };

            cancelRaf();
            rafId = requestAnimationFrame(tick);
        };

        const activateSlideAtIndex = (index) => {
            cancelRaf();
            pauseAllVideos();
            resetAllProgressBars();

            const slides = glideRoot.querySelectorAll('.glide__slide');
            const slide = slides[index];
            if (!slide) return;

            const controlBtn = controlButtons[index] || null;
            const progressEl = controlBtn ? controlBtn.querySelector('.glide__progress') : null;

            if (controlBtn) controlBtn.classList.add('glide__control--active');

            activeControlProgress = progressEl;
            activeVideo = slide.querySelector('video');

            if (activeVideo) {
                const startPlayback = () => {
                    try { activeVideo.currentTime = 0; } catch (e) {}
                    const p = activeVideo.play();
                    if (p && p.catch) p.catch((err) => {
                        console.log('Video playback failed:', err);
                    });
                    updateProgressFromVideo(activeVideo, progressEl);
                };

                if (isFinite(activeVideo.duration) && activeVideo.duration > 0) {
                    startPlayback();
                } else {
                    const onMeta = () => {
                        activeVideo.removeEventListener('loadedmetadata', onMeta);
                        startPlayback();
                    };
                    activeVideo.addEventListener('loadedmetadata', onMeta);
                    activeVideo.play().catch((err) => {
                        console.log('Video playback failed:', err);
                    });
                }

                const onEnded = () => {
                    if (progressEl) {
                        progressEl.style.width = '100%';
                        progressEl.setAttribute('aria-valuenow', '100');
                    }
                    glide.go('>');
                };
                activeVideo.removeEventListener('ended', onEnded);
                activeVideo.addEventListener('ended', onEnded);

                activeVideo.addEventListener('pause', cancelRaf);
                activeVideo.addEventListener('play', () => {
                    if (activeVideo) updateProgressFromVideo(activeVideo, progressEl);
                });
            } else {
                if (progressEl) {
                    progressEl.style.transition = 'width 1s linear';
                    progressEl.style.width = '100%';
                    progressEl.setAttribute('aria-valuenow', '100');
                    setTimeout(() => {
                        progressEl.style.transition = 'width 0.12s linear';
                        glide.go('>');
                    }, 1000);
                } else {
                    setTimeout(() => glide.go('>'), 1000);
                }
            }
        };

        // Visibility pause/resume
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                if (activeVideo) activeVideo.pause();
                cancelRaf();
            } else {
                if (activeVideo) {
                    activeVideo.play().catch(() => {});
                    updateProgressFromVideo(activeVideo, activeControlProgress);
                } else {
                    activateSlideAtIndex(glide.index);
                }
            }
        });

        // Control button clicks
        if (controlsContainer) {
            controlsContainer.addEventListener('click', (e) => {
                const btn = e.target.closest('.glide__control');
                if (!btn) return;
                const dir = btn.getAttribute('data-glide-dir') || '';
                const match = dir.match(/^=(\d+)$/);
                if (match) {
                    const idx = Number(match[1]);
                    setTimeout(() => activateSlideAtIndex(idx), 50);
                }
            });
        }

        // Glide hooks
        glide.on('mount.after', () => {
            activateSlideAtIndex(glide.index);
        });

        glide.on('run.after', () => {
            activateSlideAtIndex(glide.index);
        });

        glide.on('destroy', () => {
            cancelRaf();
            section.querySelectorAll('video').forEach((v) => {
                try {
                    v.pause();
                    const clone = v.cloneNode(true);
                    v.parentNode.replaceChild(clone, v);
                } catch (e) {}
            });
        });

        glide.mount();

        // optional debug handle
        section.videoGlide = {
            goTo: (i) => glide.go('=' + i),
            currentIndex: () => glide.index,
            destroy: () => glide.destroy(),
        };
    });
});